// extracted by mini-css-extract-plugin
module.exports = {"Root":"invoicesTable_Root__ShjCR","dropdown":"invoicesTable_dropdown__40-OI"};